<script setup>
  import { ref, defineAsyncComponent } from 'vue'

  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';

  const StatsContent = defineAsyncComponent(() => import('@/components/StatsContent.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const content = ref(null);
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="wind-stats"
      title="Statistics"
      containerTypeId="Spot Stats"
      minHeight="455px"
      >
      <template #content="{ isVisible }">
        <DataContainer style="width: 100%; height: 100%;">
          <StatsContent
             v-if="isVisible"
            v-model:content="content"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>